import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/search/transfer/kudenix',
    name: 'transfers-kudenix',
    component: () => import('../views/transfer/kudenix/agency/index.vue'),
    meta: { layout: appLayout }
  }, {
    path: '/reserve/transfer/kudenix',
    name: 'transfer-reserve-kudenix',
    component: () => import('../views/transfer/kudenix/agency/reserve.vue'),
    meta: { layout: appLayout }
  }
]
